import { Component, OnInit, Input } from '@angular/core';
import { Investor } from '../../shared/models/investor';

@Component({
  selector: 'app-insurance-details',
  templateUrl: './insurance-details.component.html',
  styleUrls: ['./insurance-details.component.css']
})
export class InsuranceDetailsComponent implements OnInit {
  @Input()
  investor: Investor;
  @Input() flags: any;

  panelState = {};
  errors: {};
  constructor() {
    this.errors = {
      "life_insurance": [],
      "health_insurance": [],
      "personal_accident_insurance": [],
    };
  }

  ngOnInit() {
    console.log('ng On Init', JSON.parse(JSON.stringify(this.investor)), JSON.parse(JSON.stringify(availableInsuranceTypes)));
    this.panelState = Object.create(availableInsuranceTypes);
    if (Object.keys(this.investor.insurances).length === 0) {
      this.investor.insurances = Object.assign({}, availableInsuranceTypes);
      Object.keys(this.investor.insurances)
      .map(k => this.investor.insurances[k])
      .map(insurances => insurances.map(insurance => {
        console.log(insurance);
        
        insurance.needed_value = null;
        insurance.existing_value = null;

        // console.log("here in here", multiplier, this.investor.total_salary_professional_income ,insurance.adequate_value);
      }));

    }
    Object.keys(this.investor.insurances)
      .map(k => this.investor.insurances[k])
      .map(insurances => insurances.map(insurance => {
        console.log(insurance);
        const multiplier = parseFloat(insurance.suggested_multiplier);
        insurance.adequate_value = Math.round((this.investor.total_salary_professional_income || 0) * 12 * suggested_multipliers[insurance.type]);
        console.log("here in here", multiplier, this.investor.total_salary_professional_income ,insurance.adequate_value);
      }));
    Object.keys(this.investor.insurances)
          .forEach(k => {
            const insuranceType = this.investor.insurances[k][0].type;
            this.panelState[k].activePanel = insuranceType;
          });
  }

  toggleInsurancePanel(type, insuranceType, activate?) {
    if(activate){
      this.panelState[type].activePanel = insuranceType;
      return;
    }
    if (this.panelState[type].activePanel === insuranceType) {
      this.panelState[type].activePanel = '';
    } else {
      this.panelState[type].activePanel = insuranceType;
    }
  }

  calculateNeededInsurance(insurance) {
    const needed_value = insurance.adequate_value - insurance.existing_value;
    insurance.needed_value = needed_value >= 0 ? needed_value : 0;
  }

  getActiveInsurancePanel(type) {
    return this.panelState[type].activePanel;
  }
  validateBeforeExit(){
    var flag = false;
    // return true;
    this.investor.insurances['life_insurance'].every(element => {
      if(element.existing_value == null){
        this.toggleInsurancePanel('life_insurance', element.type, true);
        this.errors['life_insurance'][element.type]="You must input at least zero";
        flag = true;
        return false;
      } else {
        this.errors['life_insurance'][element.type]=null;
        return true;
      }
    });
    if(flag){
      return false;
    }
    this.investor.insurances['health_insurance'].every(element => {
      if(element.existing_value == null){
        this.toggleInsurancePanel('health_insurance', element.type, true);
        this.errors['health_insurance'][element.type]="You must input at least zero";
        flag = true;
        return false;
      } else {
        this.errors['health_insurance'][element.type]=null;
        return true;
      }
    });
    if(flag){
      return false;
    }
    this.investor.insurances['personal_accident_insurance'].every(element => {
      if(element.existing_value == null){
        this.toggleInsurancePanel('personal_accident_insurance', element.type, true);
        this.errors['personal_accident_insurance'][element.type]="You must input at least zero";
        flag = true;
        return false;
      } else {
        this.errors['personal_accident_insurance'][element.type]=null;
        return true;
      }
    });
    console.log("end", flag);
    if(flag){
      return false;
    }
    return true;
  }

}

const suggested_multipliers = {
  insurance_adequate_insurance_Pure_risk_plans: 15,
  basic_health_insurance_protection_plan: 0.6,
  comprehensive_insurance_plan: 1,
  accidental_health_insurance: 6.25,
  PT_PTD_coverage: 5,
  TTD_coverage: 0.0833333333333333
}
const availableInsuranceTypes = {
  'life_insurance': [
    {
      'type': 'insurance_adequate_insurance_Pure_risk_plans',
      'name': 'Insurance adequate Insurance Pure Risk plans',
      'suggested_text': 'Suggested 15 times of annualised income',
      'suggested_multiplier': suggested_multipliers.insurance_adequate_insurance_Pure_risk_plans,
      'existing_value': null,
      'adequate_value': null,
      'needed_value': null,
      'insurance_category': ''
    }
  ],
  'health_insurance': [
    {
      'type': 'basic_health_insurance_protection_plan',
      'name': 'Basic Health Insurance Protection Plan',
      'suggested_text': 'Suggested 60% of annualised income',
      'suggested_multiplier': suggested_multipliers.basic_health_insurance_protection_plan,
      'existing_value': null,
      'adequate_value': null,
      'needed_value': null,
      'insurance_category': 'A'
    },
    {
      'type': 'comprehensive_insurance_plan',
      'name': 'Comprehensive Insurance Plan',
      'suggested_text': 'Suggested 100% of annualised income',
      'suggested_multiplier': suggested_multipliers.comprehensive_insurance_plan,
      'existing_value': null,
      'adequate_value': null,
      'needed_value': null,
      'insurance_category': 'B'
    }
  ],
  'personal_accident_insurance': [
    {
      'type': 'accidental_health_insurance',
      'name': 'Accidental Health Insurance',
      'suggested_text': 'Suggested 75 times of monthly income',
      'suggested_multiplier': suggested_multipliers.accidental_health_insurance,
      'existing_value': null,
      'adequate_value': null,
      'needed_value': null,
      'insurance_category': 'A'
    },
    {
      'type': 'PT_PTD_coverage',
      'name': 'PT/PTD Coverage',
      'suggested_text': 'Suggested 60 times of monthly income',
      'suggested_multiplier': suggested_multipliers.PT_PTD_coverage,
      'existing_value': null,
      'adequate_value': null,
      'needed_value': null,
      'insurance_category': 'B'
    },
    {
      'type': 'TTD_coverage',
      'name': 'TTD Coverage',
      'suggested_text': 'Suggested 100% of monthly income',
      'suggested_multiplier': suggested_multipliers.TTD_coverage,
      'existing_value': null,
      'adequate_value': null,
      'needed_value': null,
      'insurance_category': 'C'
    }
  ]
};




// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/insurance-details/insurance-details.component.ts